import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TratativasProdutoService {

  changeQtdeInconProdu = new EventEmitter();
  public qtdeInconsistenciasProdutos: number = 0;

  constructor(private readonly http: HttpClient) { }

  getInconsistencias(idImportacao: any) {
    const url: string = `/apiconnect/file-summary/imports/${idImportacao}/to-from/benefits-errors`;

    return this.http.get(url);
  }

  getRegioes() {
    const url: string = `/apiconnect/orders/import/regions`;

    return this.http.get(url);
  }

  getFabricantes(idRegiao: string) {
    const url: string = `/apiconnect/orders/import/product-manufacturers/${idRegiao}/regions`;

    return this.http.get(url);
  }

  getProdutos(idRegiao: string) {
    const url: string = `/apiconnect/orders/import/products/${idRegiao}/regions`;

    return this.http.get(url);
  }

  realizaDepara(body: any, idImportacao:any) {
    const url: string = `/apiconnect/file-summary/imports/${idImportacao}/to-from/benefits-errors`;
  
    return this.http.post(url, body);
  }

  ignorarTodasInconsistencias(idImportacao: any) {
    const url: string = `/apiconnect/file-summary/imports/${idImportacao}/to-from/benefits-errors/ignore-all`;

    return this.http.post(url,{});
  }

}
